import ContractsTableWithFilters from 'pages/contracts/ContractsTable';

import ListCreateButton from 'components/buttons/ListCreateButton';
import { StartClientIdentificationButton } from 'pages/client-identification/StartClientIdentificationButton';
import { PartyType } from 'types/contacts';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';

interface Props {
    contactId?: string;
    contact?: { id: number; name: string; partyType: PartyType | string };
}

const ContractsView: React.FC<Props> = ({ contactId, contact }) => {
    const navigateWithReturn = useNavigateWithReturnState();

    const toolbar: JSX.Element = (
        <div className="flex items-center gap-2">
            {contact ? <StartClientIdentificationButton party={contact} /> : null}
            <ListCreateButton
                permissions={['CREATE.CONTRACTS']}
                variant="contained"
                color="secondary"
                size="small"
                onClick={() => navigateWithReturn(`/contact/${contactId}/contract/new`)}
                labelId="contracts.add-new-contract"
                newLabelId="new-entity.contract"
            />
        </div>
    );

    if (!contactId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <ContractsTableWithFilters
                passiveFilter={`(parties.party.id=in=(${contactId}),signedByPersonParty.id=in=(${contactId}))`}
                extraHeaderComponent={toolbar}
            />
        </div>
    );
};

export default ContractsView;
